import { render, staticRenderFns } from "./_Information.vue?vue&type=template&id=270cd7e1&scoped=true&"
import script from "./_Information.vue?vue&type=script&lang=js&"
export * from "./_Information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270cd7e1",
  null
  
)

export default component.exports